import getExercises, { parseVariables } from '../_helpers/getExercises';

/**
 * Soft curriculum update — keep previous list/count/current exercise visible
 * until the debounced fetch returns (same keep-list pattern as other secondary
 * filter setters in exercises.js).
 */
const setCurriculum = (set, get) => async curriculum => {
  set(state => ({
    curriculum,
    exercises: state.exercises,
    exercisesCount: state.exercisesCount,
    fetched: state.fetched,
    currentExercise: state.currentExercise,
    section: state.section,
    subsection: state.subsection,
    orderBy: state.orderBy,
    userMarks: state.userMarks,
    isDone: state.isDone,
    filters: state.filters,
    subjectExercisesCount: state.subjectExercisesCount,
    fileType: state.fileType,
    isListFetching: true,
  }));
  const variables = parseVariables(get(), { curriculum });
  const exercises = await getExercises(variables);
  const list = exercises?.exercises ?? null;
  set({
    ...exercises,
    exerciseCursor: 0,
    currentExercise: list?.[0] ?? null,
    currentExerciseShape: { t: 0, o: 0, p: 0, a: 0 },
    fileType: 't',
    mark: null,
    allExercisesCompleted: exercises?.allExercisesCompleted ?? false,
    isListFetching: false,
  });
};

export default setCurriculum;
